// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/WorkingTimeModelSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/WorkingTimeModelSearchBy.proto.
 */
export const file_Enumerations_WorkingTimeModelSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CitFbnVtZXJhdGlvbnMvV29ya2luZ1RpbWVNb2RlbFNlYXJjaEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyrwAQoYV29ya2luZ1RpbWVNb2RlbFNlYXJjaEJ5EjIKJldPUktJTkdfVElNRV9NT0RFTF9TRUFSQ0hfQllfVEVOQU5UX0lEEAAaBsrHzQ8BAxItCiFXT1JLSU5HX1RJTUVfTU9ERUxfU0VBUkNIX0JZX05BTUUQARoGysfNDwEEEjQKKFdPUktJTkdfVElNRV9NT0RFTF9TRUFSQ0hfQllfREVTQ1JJUFRJT04QAhoGysfNDwEFEjsKL1dPUktJTkdfVElNRV9NT0RFTF9TRUFSQ0hfQllfRVhURVJOQUxfUkVGRVJFTkNFEAMaBsrHzQ8BD0IoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a working time model can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.WorkingTimeModelSearchBy
 */
export enum WorkingTimeModelSearchBy {
  /**
   * Search through the tenant id of a working time model.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the name of a working time model.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SEARCH_BY_NAME = 1;
   */
  NAME = 1,

  /**
   * Search through the description of a working time model.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SEARCH_BY_DESCRIPTION = 2;
   */
  DESCRIPTION = 2,

  /**
   * Search through the external reference text of a working time model.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SEARCH_BY_EXTERNAL_REFERENCE = 3;
   */
  EXTERNAL_REFERENCE = 3,
}

/**
 * Describes the enum time_tracking.enumerations.WorkingTimeModelSearchBy.
 */
export const WorkingTimeModelSearchBySchema: GenEnum<WorkingTimeModelSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_WorkingTimeModelSearchBy, 0);

